export default __webpack_public_path__ + "f8176f5d67d37e1388914eab505aae67.svg";